import React, { memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import OverView from '../../components/OverView'
import styles from './index.module.scss'

import Table from '@/components/Table'
import tx from '@/services/apis/tx'
import { DEFAULT_PAGE_SIZE } from '@/constants'
import { CurrentFlowStatResult } from '@/services/apis/tx/models'
import { Pagination } from '@/services/apis/BaseModel'
import { formatUSD } from '@/utils/format'
import { toThousands } from '@/utils/number'

interface FlowStatQueryProps {
  UTC: number
}
const FlowStatQuery = memo<FlowStatQueryProps>(({ UTC }) => {
  const { t } = useTranslation()

  const columns = [
    {
      title: t('analyze.date'),
      dataIndex: 'statDay',
    },
    {
      title: t('analyze.inflow'),
      dataIndex: 'inflowUsd',
      render: (record: string) => formatUSD(record),
    },
    {
      title: t('analyze.outflow'),
      dataIndex: 'outflowUsd',
      render: (record: string) => formatUSD(record),
    },
    {
      title: t('analyze.netInflow'),
      dataIndex: 'netInflowUsd',
      render: (record: string) => formatUSD(record),
    },
    {
      title: t('analyze.inflowNumber'),
      dataIndex: 'inflowNum',
      render: (record: string) => toThousands(record),
    },
    {
      title: t('analyze.outflowNumber'),
      dataIndex: 'outflowNum',
      render: (record: string) => toThousands(record),
    },
  ]

  const [flowList, setFlowList] = useState<Pagination<CurrentFlowStatResult>>()
  const [tableLoading, setTableLoading] = useState(false)
  const getList = async (page = 1) => {
    setTableLoading(true)
    const res = await tx.getFlowStatQueryByPage({
      pageNumber: page,
      pageSize: DEFAULT_PAGE_SIZE,
      statTimeZone: UTC,
    })
    setTableLoading(false)
    setFlowList(res.data)
  }
  const handleChangePage = (page: number) => {
    getList(page)
  }

  useEffect(() => {
    getList()
  }, [UTC])

  return (
    <div className={styles.container}>
      <OverView UTC={UTC} />
      <div className={styles.title} style={{ marginTop: '30px' }}>
        {t('analyze.history')}
      </div>

      <Table
        dataSource={flowList?.content}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
          total: flowList?.totalElements,
          pageSize: flowList?.pageSize,
          current: flowList?.pageNumber,
          onChange: handleChangePage,
        }}
        loading={tableLoading}
        bottomY={100}
      ></Table>
    </div>
  )
})

export default FlowStatQuery
